import { IPlanThoiGianHocLopHC } from "../../../model/respone/category/IPlanThoiGianHocLopHC";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eThoiGianHocLopHCActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as IPlanThoiGianHocLopHC[],
  LOAD_ERRR: "",

  SHOW_EDIT_MODAL: {} as IPlanThoiGianHocLopHC | undefined,
  CLOSE_EDIT_MODAL: undefined,

  SAVE_START: {} as IPlanThoiGianHocLopHC,
  SAVE_SUCCESS: undefined,
  SAVE_ERRR: "",

  DELETE_START: 0,
  DELETE_SUCCESS: undefined,
  DELETE_ERRR: "",
};

export const eThoiGianHocLopHCActionIds = generateActionTypeIds(
  eThoiGianHocLopHCActionsObj,
  "THOI_GIAN_HOC_LOP_HC"
);

export type IThoiGianHocLopHCActionTypes = IGenericActionType<
  typeof eThoiGianHocLopHCActionsObj,
  "THOI_GIAN_HOC_LOP_HC"
>;
